﻿(function () {
    "use strict";

    let app = angular.module("app");

    app.service("pricingHelper", PricingHelper);

    PricingHelper.$inject = ["request", "$rootScope"];

    function PricingHelper(request, $rootScope) {
        var self = this;

        self.budgets = {};
        self.ungroupedBudgets = [];

        var exports = {
            init: init,
            getBudgetsForYear: getBudgetsForYear
        };

        return exports;

        function init(loadedCallback) {
            loadBudgets(loadedCallback);
        }

        function loadBudgets(loadedCallback) {
            request.get($rootScope.apiEndpoint + "/budgets").then(function (response) {
                self.ungroupedBudgets = response.data.budgets
                angular.forEach(response.data.budgets, function (value) {
                    if (!self.budgets[value.year]) {
                        self.budgets[value.year] = {};
                    }
                    self.budgets[value.year][value.class] = { overhead: value.overhead, profit: value.profit, taxRate: value.taxRate };
                    self.budgets[value.year]["name"] = value.displayName;
                });

                if (loadedCallback) {
                    loadedCallback()
                }
            });
        }

        function getBudgetsForYear(year) {
          return self.ungroupedBudgets.filter(x => x.year === year)
        }
    }
})();